import controller from './vd-popover.controller'
import template from './vd-popover.html'

const PopoverComponent = {
  transclude: {
    actions: '?vdActionBar',
  },
  controller,
  template,
}

export default PopoverComponent
